import { mdiChat, mdiEye } from '@mdi/js';

import Icon from '@components/icon/Icon';
import PublicNoticeInfoModal from '../public-notice-info/PublicNoticeInfoModal';
import PublicNoticeCommentModal from '../public-notice-comment/PublicNoticeCommentModal';
import NewTooltip from '@src/app-components/tooltip/NewTooltip';
import { useModal } from '@stores';

import './actionsTableCell.scss';

const ActionsTableCell = ({ publicNotice }) => {
  const { openModal } = useModal();
  const modalPayload = { publicNoticeId: publicNotice?.publicNoticeID };
  const isAcceptPublicComments = publicNotice?.acceptPublicComments;

  const handleCommentClick = () => openModal(PublicNoticeCommentModal, modalPayload);
  const handleViewClick = () => openModal(PublicNoticeInfoModal, modalPayload);

  return (
    <div className='button-container' style={{ display: 'inline-block' }}>
      <NewTooltip label='View Full Public Notice' className='view-notice' onClick={handleViewClick}>
        <Icon focusable={false} path={mdiEye} size={'16px'} />
      </NewTooltip>
      {isAcceptPublicComments && (
        <NewTooltip label='Submit Comments' className='submit-comments' onClick={handleCommentClick}>
          <Icon focusable={false} path={mdiChat} size={'16px'} />
        </NewTooltip>
      )}
    </div>
  );
};

export default ActionsTableCell;
